import { Space } from "antd";
import { HTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";
import BackIcon from "../assets/icons/BackIcon";
import Subheader from "../components/common/Subheader";
import AppLayout from "./AppLayout";

type Props = {
  title?: string;
  children: ReactNode;
  headerTitle?: string;
  headerChildren?: ReactNode;
  subheaderTitle?: string;
  subheaderChildren?: ReactNode;
  backLink?: string;
} & HTMLAttributes<HTMLDivElement>;

export default function AdminLayout({
  title,
  headerTitle = title,
  headerChildren = null,
  subheaderTitle = "",
  subheaderChildren = null,
  backLink,
  children,
  ...rest
}: Props) {
  return (
    <AppLayout title={title} {...rest}>
      {headerTitle || headerChildren ? (
        <Space
          wrap={true}
          align="center"
          className="flex justify-between mb-4 header_children"
        >
          <h3 className="text-body text-2xl font-medium leading-9">
            <div className="flex items-center gap-6">
              {backLink ? (
                <Link className="flex items-center" to={backLink}>
                  <BackIcon />
                </Link>
              ) : null}
              {headerTitle}
            </div>
          </h3>
          {headerChildren && <div>{headerChildren}</div>}
        </Space>
      ) : null}

      {subheaderTitle || subheaderChildren ? (
        <Subheader title={subheaderTitle}>{subheaderChildren}</Subheader>
      ) : null}

      <main>{children}</main>
    </AppLayout>
  );
}
